// extracted by mini-css-extract-plugin
module.exports = {"text":"ReadMore_text__UKDrq","isOpen":"ReadMore_isOpen__HhvEx"};